export const NVM = {
  id: "diskType",
  name: "Тип диску",
  description: "Тип диску",
  options: [
    {
      name: "Тип диску",
      translated_names: {
        ru: "Тип диска",
        ua: "Тип диску",
        en: "Disk type"
      },
      id: "diskType",
      type: "radio",
      hidden: false,
      order: 1,
      opts: [
        {
          id: 1,
          name: "SSD",
          translated_names: {
            ru: "SSD",
            ua: "SSD",
            en: "SSD"
          },
          hidden: false
        },
        {
          id: 2,
          name: "NVMe — в 3 раза быстрее, чем SSD (доступно в датацентре Роттердама)",
          translated_names: {
            ru: "NVMe — в 3 раза быстрее, чем SSD (доступно в датацентре Роттердама)",
            ua: "NVMe — в 3 рази швидше за SSD (доступно в датацентрі Роттердаму)",
            en: "NVMe — three times faster than SSD (available in the Rotterdam datacenter)"
          },
          hidden: false
        }
      ],
      tooltip: {
        ru: "NVMe-диски загружают данные на сайте в 3 раза быстрее, чем SSD",
        ua: "NVMe-диски завантажують дані на сайті в 3 рази швидше за SSD",
        en: "NVMe disks load your website data three times faster than SSD"
      }
    }
  ]
}
